import { useSeo } from "@/lib/site";
import { PageHero } from "@/components/site/PageHero";
import { CtaBand, CtaButton, BookMeeting } from "@/components/site/Blocks";
import { CaseStudies } from "@/components/results/CaseStudies";
import { VideoWork } from "@/components/results/VideoWork";

const COLLAGE = ["/cases/funderland.webp", "/cases/keenan.webp", "/cases/drew.webp", "/cases/marlay.webp"];

const Collage = () => (
  <div className="absolute inset-0 grid grid-cols-2 gap-2 bg-[#100a26] p-2">
    {COLLAGE.map((src) => <img key={src} src={src} alt="" className="h-full w-full rounded-[20px] object-cover" />)}
  </div>
);

export default function Results() {
  useSeo("Case Studies & Client Results | Perfect Digitals", "Case studies and client results from Perfect Digitals across SEO, advertising, website design and AI video production.");
  return (
    <div data-testid="results-page">
      <PageHero
        crumb={["Results"]}
        title={["Results,", <span className="font-serif-i text-gradient">Not Just</span>, "Rankings"]}
        sub="Search visibility ultimately needs to contribute to business growth."
        paras={["That is why we look beyond individual keyword positions.", "Our goal is not simply to make graphs move upwards. It is to make your business easier for potential customers to discover."]}
        ctas={<><BookMeeting testid="hero-primary-cta" /><CtaButton label="Speak to a Search Specialist" variant="ghost" testid="hero-secondary-cta" /></>}
        visual={<Collage />}
      />
      <CaseStudies />
      <VideoWork />
      <CtaBand
        title={["Let's Talk About", <span className="font-serif-i text-gradient">Your Search</span>, "Visibility"]}
        paras={["Book a meeting with our team or get in touch to discuss your visibility across Google and AI search."]}
        ctas={<><BookMeeting testid="final-primary-cta" /><CtaButton label="Contact Us" variant="ghost" testid="final-secondary-cta" /></>}
      />
    </div>
  );
}
